import { ArticleHeading2, UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import * as styles from './MobileGenericService.css';
import { IGenericServiceProps } from '../GenericService';

export const MobileGenericService = ({
  onClick,
  dataName,
  bgColor,
  checked,
  unavailable,
  title,
  subtitle,
  children,
  className,
}: IGenericServiceProps) => {
  return (
    <div
      data-name={dataName}
      className={classNames(
        styles['card'],
        styles[bgColor],
        className,
        checked && styles['checked'],
        unavailable && styles['unavailable'],
      )}
      onClick={onClick}
    >
      <div className={styles['header']}>
        <div>
          <ArticleHeading2>{title}</ArticleHeading2>
          {subtitle && <UIText1>{subtitle}</UIText1>}
        </div>
      </div>

      <div>{children}</div>
    </div>
  );
};
